import { CloseIcon } from "@chakra-ui/icons";
import {
  Button,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import colors from "common/theme/foundations/colors";

const LogoutModal = (props) => {
  const { isOpen, onClose, handleLogout } =
    props;


  const handleClose = () => {
    onClose();
  };

  return (
    <div>
      <Modal onClose={onClose} isOpen={isOpen} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Log out</ModalHeader>
          <IconButton
            size="xs"
            className="closeIcon"
            onClick={props.onClose}
            icon={<CloseIcon />}
          />

          <ModalBody>Are you sure you want to Log out?</ModalBody>
          <ModalFooter>
            <Button
               className="theme-btn2"
               variant="outline"
               size="sm"
              onClick={handleClose}
            >
              No
            </Button>
            <Button
            className="theme-btn3"
            colorScheme={colors.red[500]}
            size="sm"             
              ml={4}
              onClick={handleLogout}
            >
            Log out
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default LogoutModal;
